import { render, staticRenderFns } from "./_sanity.vue?vue&type=template&id=0b7298ce"
import script from "./_sanity.vue?vue&type=script&lang=js"
export * from "./_sanity.vue?vue&type=script&lang=js"
import style0 from "./_sanity.vue?vue&type=style&index=0&id=0b7298ce&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports